document.addEventListener("DOMContentLoaded", () => {
  const searchLabel = document.querySelector(
    ".search-modal__form .field__label"
  );
  if (!searchLabel) return;

  const WORDS = ["products", "collections", "blog posts"];
  const BASE_TEXT = "Search for ";
  const TYPING_SPEED = 100; // ms per character
  const DISPLAY_DURATION = 2500; // ms to display full word
  const PAUSE_BETWEEN = 500; // ms pause after clearing

  let currentIndex = 0;
  let animationId = null;

  // Helper function for readable delays
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Main animation controller
  const runAnimation = async () => {
    while (true) {
      const word = WORDS[currentIndex];

      // Type current word
      for (let i = 0; i <= word.length; i++) {
        if (!searchLabel.isConnected) return; // Exit if element removed
        searchLabel.textContent = BASE_TEXT + word.slice(0, i);
        await sleep(TYPING_SPEED);
      }

      // Pause with full word displayed
      await sleep(DISPLAY_DURATION);

      // Clear word
      searchLabel.textContent = BASE_TEXT;
      await sleep(PAUSE_BETWEEN);

      // Move to next word
      currentIndex = (currentIndex + 1) % WORDS.length;
    }
  };

  // Start animation with safety checks
  const startAnimation = async () => {
    if (!searchLabel.isConnected) return;
    try {
      await runAnimation();
    } catch (e) {
      console.error("Animation error:", e);
    }
  };

  // Start the animation
  startAnimation();
});
